import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function SpecialDaysView({ store, navigate }) {
  const { state, addSpecialDay, deleteSpecialDay, getMonthRecord } = store;
  const { specialDays, brands, managers, currentMonth } = state;
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const monthDays = specialDays.filter(sd => sd.month === currentMonth);
  const fmtM = currentMonth ? new Date(currentMonth+'-01').toLocaleDateString('en-GB',{month:'long',year:'numeric'}) : '';

  const handleAdd = () => {
    if (!name.trim() || !date) return;
    addSpecialDay(name.trim(), date, currentMonth);
    setName(''); setDate('');
  };

  return (
    <div>
      <h1 className="page-title">Special days</h1>
      <p className="page-sub">{fmtM} — track creative delivery for special occasions</p>

      <div className="add-bar">
        <input placeholder="e.g. Father's Day, Vesak..." value={name} onChange={e=>setName(e.target.value)} style={{minWidth:180}} />
        <input type="date" value={date} onChange={e=>setDate(e.target.value)} />
        <motion.button className="btn btn-accent" whileTap={{scale:.96}} onClick={handleAdd}>Add day</motion.button>
      </div>

      {monthDays.length === 0 ? (
        <div className="empty-state">
          <p>No special days for {fmtM}.</p>
          <p style={{ fontSize:13, marginTop:6 }}>Add one above to start tracking.</p>
        </div>
      ) : (
        <AnimatePresence>
          {monthDays.map(sd => {
            const done = brands.filter(b => {
              const rec = getMonthRecord(b.id, currentMonth);
              return rec.specialDaysDone?.[sd.id];
            }).length;
            const total = brands.length;
            return (
              <motion.div key={sd.id} className="sd-card"
                initial={{opacity:0,y:12}} animate={{opacity:1,y:0}} exit={{opacity:0,scale:.97}}
                transition={{duration:.25}}
              >
                <div className="sd-header">
                  <div>
                    <div className="sd-name">{sd.name}</div>
                    <div className="sd-date">
                      {new Date(sd.date).toLocaleDateString('en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}
                    </div>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:10, flexShrink:0 }}>
                    <span className={`badge ${done===total?'green':done>0?'amber':'red'}`} style={{ fontSize:13, padding:'5px 12px' }}>
                      {done}/{total} done
                    </span>
                    <button className="btn btn-ghost btn-sm" style={{ color:'var(--red)', borderColor:'var(--red-bg)' }} onClick={() => deleteSpecialDay(sd.id)}>
                      Remove
                    </button>
                  </div>
                </div>
                <div style={{ borderTop:'1px solid var(--border)' }}>
                  <div className="tbl-wrap" style={{ borderRadius:0, border:'none' }}>
                    <table>
                      <thead>
                        <tr><th>Brand</th><th>Manager</th><th>Status</th><th>Action</th></tr>
                      </thead>
                      <tbody>
                        {brands.map(b => {
                          const mgr = managers.find(m=>m.id===b.managerId);
                          const rec = getMonthRecord(b.id, currentMonth);
                          const isDone = rec.specialDaysDone?.[sd.id]||false;
                          return (
                            <tr key={b.id}>
                              <td style={{ fontWeight:600 }}>{b.name}</td>
                              <td>
                                <span style={{ display:'inline-block', fontSize:11, padding:'2px 9px', borderRadius:20, color:'#000', fontWeight:600, background:mgr?.color||'#666' }}>
                                  {mgr?.name}
                                </span>
                              </td>
                              <td>
                                {isDone
                                  ? <span className="badge green">Done</span>
                                  : <span className="badge red">Pending</span>
                                }
                              </td>
                              <td>
                                <button className="btn btn-ghost btn-sm" onClick={()=>navigate('brand',{brand:b.id})}>
                                  Open →
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
      )}
    </div>
  );
}
